import client from './client'

export default {
  list: () => client.get('/api/admin/franchises'),

  get: (id) => client.get(`/api/admin/franchises/${id}`),
          
  update: (id, data) => 
    client.put(`/api/admin/franchises/${id}`) 
          .send({ franchise: data }),
  
  del: (id) => client.del(`/api/admin/franchises/${id}`),
}
